/**
 * Demo shortcuts: `/demo/<screen>` jumps straight to a screen of the offline demo, setting up any
 * state it needs (connection state, first-run tips, "since you last looked").
 */
import { useEffect } from 'react';
import { navigate } from '../app/router';
import { DEMO_CODES } from './demoCodes';
import type { DemoShortcut } from './demoShortcuts';

const R = DEMO_CODES.running;

/** Applies a shortcut's setup, then replaces the URL with its target. */
export function DemoShortcutRoute({ shortcut }: { shortcut: DemoShortcut }) {
  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const { demoServer, demoMemory } = await import('./demoBackend');
      if (cancelled) return;
      switch (shortcut.setup) {
        case 'offline':
        case 'reconnecting':
          demoServer.connection = shortcut.setup;
          break;
        case 'online':
          demoServer.connection = 'online';
          break;
        case 'onboarding':
          demoMemory.set(R, 'onboarded', false);
          demoMemory.set(R, 'hints', []);
          break;
        case 'since':
          demoMemory.set(R, 'lastSeen', { now: 2 * 1440 + 14 * 60 + 20 - 8 * 60 - 9 * 60, score: [33, 30] });
          demoMemory.set(R, 'dispatchReadDay', 3);
          break;
        default:
          break;
      }
      navigate(shortcut.to, { replace: true });
    })();
    return () => {
      cancelled = true;
    };
  }, [shortcut]);
  return null;
}
